var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-empty"},[_c('div',{staticClass:"auth-text"},[_vm._v("请联系管理员开通权限！")])])}]

export { render, staticRenderFns }